import { $, owlCarousel } from "./imports";

const processCarousel = () => {

    if($('.block-process__list .block-process__item').length > 1){
        let $processCarouselDservice = $('.block-process__list .view-service-process-results > .view-content').addClass('owl-carousel').owlCarousel({
            nav: true,
            dots: false,
            navText: [
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M15.514,6l1.627,1.627-5.285,5.3,5.285,5.3-1.627,1.627L8.59,12.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M10.217,6,8.59,7.627l5.285,5.3L8.59,18.22l1.627,1.627,6.923-6.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>'
            ],
            loop: true,
            autoplay: true,
            autoplayTimeout: 8000,
            autoplayHoverPause: true,
            items: 1,
            // center: true,
            responsive: {
                0:{
                    nav: false,
                    dots: true,
                },
                768: {
                    nav: true,
                    dots: false,
                }
            }
        });

        function doPosCalculations(el) {
            const height = el.height();
            const {top, left} = el.position();
            const res = height + top + 24;
          
            // set OwlDots Position
            $processCarouselDservice.find(".owl-dots").css('top', `${height + top + 28}px`);

            // set OwlNav Position
            $processCarouselDservice.find(".owl-nav").css({
                top: `${res}px`,
                left: `${left}px`
            });
        }

        function setOwlNavigationPosition() {
            const $target = $processCarouselDservice.find(".owl-item.active .process-txt");
            doPosCalculations($target);
        }        
        
        $processCarouselDservice.on("changed.owl.carousel", (event) => {
            // let currentIndex = event.item.index;            
            const $currentOwlItem = $processCarouselDservice.find(".owl-item").eq(event.item.index);
            
            const $target = $currentOwlItem.find(".process-txt");
            
            doPosCalculations($target);
            
        });
        
        // Cuando se ha redimensionado
        $processCarouselDservice.on("resized.owl.carousel", (event) => {
            setOwlNavigationPosition();
        });
        
        setOwlNavigationPosition();
    }
}

export default processCarousel;